import { connect } from "react-redux";
import { BlockUI } from './views/Utility.jsx';
import AppHeader from "./Layout/AppHeader";
import AppSidebar from "./Layout/AppSidebar";
import AppFooter from "./Layout/AppFooter";
import ThemeOptions from "./Layout/ThemeOptions";
import { useResizeDetector } from "react-resize-detector";
import cx from "classnames";
import { Fragment } from "react";
import { Outlet, useNavigation } from 'react-router-dom';

const Layout = (props) => {
    const {
    colorScheme,
    enableFixedHeader,
    enableFixedSidebar,
    enableFixedFooter,
    enableClosedSidebar,
    enableMobileMenu,
    enablePageTabsAlt,
  } = props;

   const { width, ref } = useResizeDetector();
    return (
      <Fragment>
        {/* <ThemeOptions /> */}
        <div ref={ref}>
          <div
            className={cx(
              "app-container app-theme-" + colorScheme,
              { "fixed-header": enableFixedHeader },
              { "fixed-sidebar": enableFixedSidebar || width < 992 },
              { "fixed-footer": enableFixedFooter },
              { "closed-sidebar": enableClosedSidebar || width < 992 },
              {
                "closed-sidebar-mobile": width < 992,
              },
              { "sidebar-mobile-open": enableMobileMenu },
              { "body-tabs-shadow-btn": enablePageTabsAlt }
            )}>
            <AppHeader />
            <div className="app-main">
              <AppSidebar />
              <div className="app-main__outer">
                <div className="app-main__inner">
                   { useNavigation().state === 'loading' ? (<BlockUI />) : (<Outlet />)}
                </div>
                <AppFooter />
              </div>
            </div>
          </div>
        </div>
      </Fragment>
  );
}

export const mapStateToProp = (state) => ({
  colorScheme: state.ThemeOptions.colorScheme,
  enableFixedHeader: state.ThemeOptions.enableFixedHeader,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  enableFixedFooter: state.ThemeOptions.enableFixedFooter,
  enableFixedSidebar: state.ThemeOptions.enableFixedSidebar,
  enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
  enablePageTabsAlt: state.ThemeOptions.enablePageTabsAlt,
});

export default connect(mapStateToProp)(Layout);

